import { Row } from "../types";
import { Region } from "../../../features/regions/types";
import { Country } from "../../../features/countries/types";

export const getAvailableCountries = (
  rows: Row[],
  row: Row,
  countriesAll: Country[],
  regionsData: Region[]
): string[] => {
  const fittedRow = rows.find((r) => r.id === row.id);

  if (fittedRow) {
    const matchingRegionName = regionsData.find(
      (region) => region.id === fittedRow.region_id
    )?.name;

    return countriesAll
      .filter(
        (country) => country.country_name.toUpperCase() !== matchingRegionName
      )
      .sort((a, b) => a.country_name.localeCompare(b.country_name))
      .map((country) => country.id);
  }
  return [];
};
